import React from "react";
import { Box, Card, Typography } from "@mui/material";

const RejectRemaks = ({ status_id, remarks }: { status_id: number, remarks: string }) => {
    return (
        <>
            <Card
                sx={{ mt: 2, boxShadow: "none", border: "1px solid #E7E8E9", pb: 2 }}>
                <Box
                    sx={{
                        backgroundColor: "#F0D4D2",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #E7E8E9",
                        py: "8px",
                        pl: 2
                    }}>
                    <Typography
                        sx={{
                            fontFamily: "Inter, sans-serif",
                            fontWeight: 500,
                            fontSize: "18px",
                            lineHeight: "20px", 
                            color: "#B3261D",
                            p: 1
                        }}
                        fontWeight="semi-bold">
                        Application Rejected Reason
                    </Typography>
                </Box>
                <Box className="bg-gray-200 p-4 mx-4 mt-4 rounded-md">
                    <Typography className="body-m text-gray-700">
                        {remarks}
                    </Typography>
                </Box>
            </Card>
        </>
    )
}

export default RejectRemaks